import { render, staticRenderFns } from "./AppSidebarProfile.vue?vue&type=template&id=037bc808&"
import script from "./AppSidebarProfile.vue?vue&type=script&lang=ts&"
export * from "./AppSidebarProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AppSidebarProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports